import { cardRef, defineGameCard, onAppear } from '../authoring/index.js';
import { applyThorns, crown, isLiveOnBoard, maturation, photosynthesis } from './plant-helpers.js';
/**
 * Саженец чёрного тёрна: при раскрытии кладёт Колючки напротив; Созревание 4
 * превращает его в Зрелый тёрн 8/10.
 */
export const BlackthornSaplingCard = defineGameCard({
    id: 'blackthorn_sapling',
    gameplay: {
        type: 'UNIT',
        cost: 3,
        baseStats: { attack: 0, health: 5 },
        traits: ['PLANT', 'TREE'],
        keywords: ['CANNOT_ATTACK'],
    },
    presentation: {
        name: 'Саженец чёрного тёрна',
        description: 'При раскрытии наложите Колючки 1 на ячейку напротив. Не атакует. Фотосинтез. Крона. Созревание 4: превращается в Зрелый тёрн 8/10.',
        glyph: {
            colors: ['#10213A', '#4E7E35', '#6DA737', '#392428', '#392428'],
            rows: [
                '..........1.........',
                '.........121........',
                '........12331.......',
                '........13231.......',
                '.........121........',
                '..11......4.....11..',
                '.122111...4....1321.',
                '.1233221..4...13321.',
                '..1233321.4..123221.',
                '..1233321.4.123321..',
                '...122324.4432221...',
                '....1111.44.1111....',
                '..........4.........',
                '..........4.4.......',
                '........4.44........',
                '.........44.........',
                '..........4.........',
                '..........4.........',
                '..........44........',
                '..........4.........',
            ],
        },
    },
    role: 'playable',
    abilities: [
        onAppear({
            source: 'card_effect',
            dependencies: [cardRef('plant_thorns')],
            run: (ctx) => {
                const self = ctx.self;
                if (!isLiveOnBoard(self))
                    return;
                const opposite = ctx.q.opposingCell(self.cellId);
                if (opposite !== null)
                    applyThorns(ctx, opposite.id, 1, self.controllerId);
            },
        }, { cause: 'played' }),
        ...photosynthesis(),
        ...crown(),
        maturation('blackthorn_sapling', 4, { id: 'mature_blackthorn', attack: 8, health: 10 }),
    ],
    ui: {
        mechanics: ['cannot_attack', 'growth', 'photosynthesis', 'crown', 'maturation', 'thorns'],
    },
});
//# sourceMappingURL=blackthorn_sapling.js.map